export default __webpack_public_path__ + "static/media/Stellosysy-Logo-sign.5257f7ec.svg";